export const sharepointTabConfig = {
  lists: {
    label: 'Lists',
    key: 'lists', 
    idField: 'id',
    nameField: 'title'
  },
  document_libraries: {
    label: 'Document Libraries',
    key: 'document_libraries',
    idField: 'id', 
    nameField: 'title'
  }
};